import React, { FC, useEffect, useState } from "react";
import { Row, Col, Modal, Layout } from "antd";
import DashboardModal from "./DashboardModal";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";

const DashboardWrapper: FC<{ socket: ISocket }> = ({ socket }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  return (
    <Modal
      title=""
      visible={true}
      width="100%"
      className="beam-modal analytics-summary-modal"
      footer={[]}
      destroyOnClose={true}
      closable={false}
    >
      <Layout className="main-layout exec-layout mr-4" style={{ padding: 0 }}>
        <DashboardModal socket={socket} />
      </Layout>
    </Modal>
  );
};

export default DashboardWrapper;
